//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Settings Context
//
//  Copyright:    © 2022 - 2023 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//region Version 1.0.0.0
//    001   16.11.22 Sean Flook         WI????? Initial Revision.
//endregion Version 1.0.0.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

//region imports

import React from "react";

//endregion imports

const SettingsContext = React.createContext();
SettingsContext.displayName = "SettingsContext";

export default SettingsContext;
